module.exports = __webpack_public_path__ + "img/loading.63587320.svg";